export function withDataStateLocalOverrides(dataState, LSdataStateName) {
  const localOverrides = localStorage.getItem(LSdataStateName);

  if (!localOverrides) {
    return dataState;
  }

  const overrides = JSON.parse(localOverrides);

  const walkThrueFilters = filters => {
    return filters.reduce((results, item) => {
      if (item.filters) {
        item.filters = walkThrueFilters(item.filters);
      }

      // FIX DATE Field value 🦄
      // No correct way how to check if string is date so we checking if
      // it's string and string is not only digits
      // and after that we check if getTiem is not NaN
      // I Hope i will be cover all cases 🙃
      if (
        item.value &&
        typeof item.value === 'string' &&
        !/^\d+$/.test(item.value)
      ) {
        item.value =
          !isNaN(new Date(item.value).getTime()) &&
          item.value.length > 0 &&
          !isNaN(parseInt(item.value[0], 10)) &&
          new Date(item.value).getFullYear() > 1900
            ? new Date(item.value)
            : item.value;
      }

      results.push({
        ...item
      });

      return results;
    }, []);
  };

  const filter = overrides.filter
    ? {
        ...overrides.filter,
        filters: walkThrueFilters(overrides.filter.filters)
      }
    : {};

  const addtional = {};

  if (Object.keys(filter).length > 0) {
    addtional.filter = filter;
  }

  return {
    ...dataState,
    ...{
      ...overrides,
      ...addtional
    }
  };
}

export function withGridLocalOverrides(defaultColumns, LSGridPropsName) {
  const localOverrides = localStorage.getItem(LSGridPropsName);

  if (!localOverrides) {
    return defaultColumns;
  }

  // set all invisible
  Object.getOwnPropertyNames(defaultColumns).forEach(key => {
    defaultColumns[key].visible = false;
  });

  // from local overrides set visible fields with configurations
  JSON.parse(localOverrides).columns.forEach(item => {
    // since data selection is dynamic (in case of location), we should always take it from the server.
    if (item && item.customFilter && item.customFilter.data) {
      var field = defaultColumns[item.field];
      if (field && field.customFilter) {
        item.customFilter.data = field.customFilter.data;
      }
    }

    return (defaultColumns[item.field] = {
      ...defaultColumns[item.field],
      order: item.order,
      ...item
    });
  });

  const keys = Object.getOwnPropertyNames(defaultColumns);

  const result = keys.reduce((results, key) => {
    results[key] = defaultColumns[key];
    return results;
  }, {});

  return result;
}

export const onUserResetSettings = (
  LSdataStateName,
  LSGridPropsName,
  NotificationsQueryFilterName,
  callback
) => () => {
  localStorage.removeItem(LSdataStateName);
  localStorage.removeItem(LSGridPropsName);
  localStorage.removeItem(NotificationsQueryFilterName);

  callback();
};
